var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "range-slider" }, [
    _c("div", { staticClass: "w-50" }, [
      _c(
        "div",
        { staticClass: "mb-2" },
        [
          _c("vue-slider", {
            attrs: {
              tooltip: "none",
              interval: 15,
              min: 0,
              max: 1440,
              value: _vm.valueC,
              "enable-cross": false
            },
            on: { change: _vm.onInput }
          })
        ],
        1
      )
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "form-control d-flex justify-content-between",
        staticStyle: { "max-width": "150px" }
      },
      [
        _c("b", [_vm._v(_vm._s(_vm.start))]),
        _vm._v("-\n        "),
        _c("b", [_vm._v(_vm._s(_vm.end))])
      ]
    )
  ])
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-08523577", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-08523577","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/front/components/widgets/common/TimeRangeSlider.vue
// module id = null
// module chunks = 